import React from "react";
import { Box } from "common";

const RewardMilestoneView = ({ values }: { values: any }) => {
  return (
    <Box
      gridGap="10px"
      style={{
        width: "100%",
        textAlign: "center",
        minWidth: "250px",
      }}
    >
      <Box
        style={{
          display: "grid",
          gridTemplateColumns: "0.6fr 1fr 1fr 1fr",
        }}
      >
        <h3 style={{ margin: 0, fontSize: "12px", paddingLeft: "5px" }}>
          Step
        </h3>
        <h3 style={{ margin: 0, fontSize: "12px", paddingLeft: "5px" }}>MOV</h3>
        <h3 style={{ margin: 0, fontSize: "12px", paddingLeft: "5px" }}>
          Type Of Reward
        </h3>
        <h3 style={{ margin: 0, fontSize: "12px", paddingLeft: "5px" }}>
          Reward
        </h3>
      </Box>
      {values?.map((data: any, index: number) => (
        <Box
          key={`inc_disc_${index}`}
          style={{
            display: "grid",
            gridTemplateColumns: "0.6fr 1fr 1fr 1fr",
          }}
        >
          <Box style={{ paddingLeft: "5px" }}>{data?.step || ""}</Box>
          <Box style={{ paddingLeft: "5px" }}>
            {data?.restrictions?.minOrderValue || ""}
          </Box>
          <Box style={{ paddingLeft: "5px" }}>{data?.discount?.mode || ""}</Box>
          <Box style={{ paddingLeft: "5px" }}>{data?.discount?.name || ""}</Box>
        </Box>
      ))}
    </Box>
  );
};

export default RewardMilestoneView;
